// src/UserPool.js
import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: "us-east-1_qlAxgRg2V",
  ClientId: "4gqq6p84qp26unendvf6uuri1a",
};

export default new CognitoUserPool(poolData);
